import { gql } from '@apollo/client';

const insertPlantOrderMutation = gql`
    mutation insertPlantOrder($email: String!, $order: [Int!]!) {
        insert_plant_order_one(object: { email: $email, order: $order }) {
            email
        }
    }
`;

export default insertPlantOrderMutation;
